import { debounce } from 'lodash-es';

const COUNTRY_MAP_CACHE_KEY = 'countryMapCache';
const WORLD_MAP_CACHE_KEY = 'worldMapChartDataCache';

const CACHE_EXPIRY_MS = 8 * 60 * 60 * 1000; // 8小时
const DEBOUNCE_WAIT = 300;

const MAX_CACHE_UPDATES = 20;
const MAX_LOG_COUNT = 10;

// countryMap 更新计数
let countryMapUpdateCount = 0;

// 日志打印计数
let logPrintCount = 0;

// 获取国家缓存数据
export function getCountryMapCache() {
  const cachedData = localStorage.getItem(COUNTRY_MAP_CACHE_KEY);

  if (logPrintCount < MAX_LOG_COUNT) {
    // console.debug('[Cache] Current cache:', cachedData?.slice(0, 100));

    if (logPrintCount === MAX_LOG_COUNT) {
      // console.debug('[Cache] Log printing limited for getCountryMapCache');
    }
  }

  if (!cachedData) {
    if (logPrintCount < MAX_LOG_COUNT) {
      // console.debug('[Cache] No cache found');
    }
    return null;
  }

  try {
    const { data, timestamp } = JSON.parse(cachedData);
    const isExpired = Date.now() - timestamp > CACHE_EXPIRY_MS;
    return isExpired ? null : data;
  } catch (e) {
    return null;
  }
}

export const setCountryMapCache = debounce((data: any) => {
  if (countryMapUpdateCount >= MAX_CACHE_UPDATES) return;

  // eslint-disable-next-line no-plusplus
  countryMapUpdateCount++;

  // console.debug('[CountryMapCache] Setting cache with', data.length, 'items', {
  //   data,
  //   countryMapUpdateCount,
  // });

  const cacheData = {
    data,
    timestamp: Date.now(),
  };

  localStorage.setItem(COUNTRY_MAP_CACHE_KEY, JSON.stringify(cacheData));
}, DEBOUNCE_WAIT);

export function resetCacheUpdateCount() {
  countryMapUpdateCount = 0;
  logPrintCount = 0;

  // console.debug('[CountryMapCache] resetCacheUpdateCount invokeed', {
  //   countryMapUpdateCount,
  //   logPrintCount,
  // });
}

// export function getWorldMapCache() {
//   const cachedData = localStorage.getItem(WORLD_MAP_CACHE_KEY);
//   if (!cachedData) return null;

//   try {
//     const { data, timestamp } = JSON.parse(cachedData);
//     const isExpired = Date.now() - timestamp > CACHE_EXPIRY_MS;

//     return isExpired ? null : data;
//   } catch (e) {
//     return null;
//   }
// }

// export const setWorldMapCache = debounce((data: any) => {
//   const cacheData = {
//     data,
//     timestamp: Date.now(),
//   };

//   localStorage.setItem(WORLD_MAP_CACHE_KEY, JSON.stringify(cacheData));
// }, DEBOUNCE_WAIT);
